import React from "react";
import { graphql } from "gatsby";
import Img from "gatsby-image";
import SEO from "../../components/SEO/SEO";
import Layout from "../../components/Layout/Layout";
import FlexibleLayout from "../../components/FlexibleLayout";
import SocialShare from "../../components/SocialShare/SocialShare";
import { ReactComponent as TimeSvg } from "../../assets/svgs/time.svg";
import { ReactComponent as CalendarSvg } from "../../assets/svgs/calendar.svg";
import BackButton from "../../components/BackButton/BackButton";
import FluidImage from "../../components/FluidImage/FluidImage";

import "./idea.scss";

const idea = ({ data, pageContext, location }) => {
  const { page } = data;
  const { flexibleLayout, seo, author, baseFields, ideaMetaFields } = page;
  const IdeaShortDescription = baseFields.previewDescription;
  const FeaturedImage = baseFields.previewImage?.localFile.childImageSharp.fluid;

  return (
    <>
      <SEO seoData={seo} uri={page.uri} />
      <Layout bodyClass={page.slug} pageContext={pageContext} location={location}>
        <SocialShare title={page.title} url={location.href} />
        <section className="IdeaHeader">
          <div className="container">
            <BackButton to="/insights/" variant="mixed">
              Back to insights
            </BackButton>
            <h3 className="Text--light">{page.title}</h3>
            <div
              className="IdeaShortDescription"
              dangerouslySetInnerHTML={{ __html: IdeaShortDescription }}
            />
          </div>
        </section>
        <div className="IdeaContentainer container">
          {FeaturedImage && (
            <div className="IdeaFeaturedImage">
              <Img fluid={FeaturedImage} alt={baseFields.previewImage.altText} />
            </div>
          )}
          <div className="IdeaPostMeta">
            <div className="IdeaPostMetaItem">
              <FluidImage className="IdeaAvatar" image={author.node.avatar} />
              <span className="IdeaAthorName">by {author.node.name}</span>
            </div>
            <div className="IdeaPostMetaItem">
              <CalendarSvg className="icon" />
              <span className="IdeaDate">{page.date}</span>
            </div>
            {ideaMetaFields.minutesToRead && (
              <div className="IdeaPostMetaItem">
                <TimeSvg className="icon" />
                <span>{`${ideaMetaFields.minutesToRead} min read`}</span>
              </div>
            )}
          </div>
          <div className="Ideacontent" dangerouslySetInnerHTML={{ __html: page.content }} />
        </div>
        {flexibleLayout?.flexibleChildren &&
          flexibleLayout?.flexibleChildren.map((layout, index) => {
            return <FlexibleLayout key={index} layout={layout} pageContext={pageContext} />;
          })}
      </Layout>
    </>
  );
};

export const query = graphql`
  query idea($databaseId: Int!) {
    page: wpInsight(databaseId: { eq: $databaseId }) {
      ...IdeaPostContent
    }
  }
`;

export const fragments = graphql`
  fragment IdeaPostContent on WpInsight {
    title
    content
    uri
    date(formatString: "LL")
    modifiedGmt
    slug
    author {
      node {
        name
        avatar {
          url
          width
          height
          localFile {
            ...AvatarImage
          }
        }
      }
    }

    seo {
      ...SeoData
    }
    baseFields {
      previewDescription
      previewImage {
        ...IdeaHeaderImage
      }
    }
    ideaMetaFields {
      minutesToRead
    }
    flexibleLayout {
      flexibleChildren {
        __typename
        ...Idea_HeroCta
        ...Idea_RelatedItems
      }
    }
  }
`;

export default idea;
